import React from "react";
import styled from "styled-components";
// @ts-ignore
import { moment, CWBTimePicker } from "cwb-react";
import { withI18n } from "react-i18next";
import { Button } from "../../Common";
import { Popover, PopoverBody } from "reactstrap";

const DisplayPopOver = ({
  scheduleId,
  popoverOpen,
  deleteCheckIn,
  saveCheckInfo,
  toggle,
  updateTime,
  checkInfo,
  t,
}: any) => {
  if (!checkInfo) return null;
  const selectedInTime = moment.moment(checkInfo.checkedIn, "h:mm A").format("HH:mm");
  const selectedOutTime = moment.moment(checkInfo.checkedOut, "h:mm A").format("HH:mm");
  return (
    <>
      <Popover
        placement="bottom"
        isOpen={popoverOpen}
        target={`Popover${scheduleId}`}
        toggle={toggle}
      >
        <PopoverBody>
          <StyledDiv>
            <Label>{t("Check-in Time")}:</Label>
            <CWBTimePicker
              selectedTime={selectedInTime}
              format={"hh:mm a"}
              onChange={(time: any) => updateTime(time, "checkin")}
              clearIcon={true}
              hideClock={true}
              disableClock={true}
            />
          </StyledDiv>
          <StyledDiv>
            <Label>{t("Check-out Time")}:</Label>
            <CWBTimePicker
              selectedTime={selectedOutTime}
              format={"hh:mm a"}
              onChange={(time: any) => updateTime(time, "checkout")}
              clearIcon={true}
              hideClock={true}
              disableClock={true}
            />
          </StyledDiv>
          <StyledDiv style={{ padding: "16px 0", flexDirection: "row" }}>
            <StyledButton
              style={{ width: "96px" }}
              variant="secondary"
              onClick={toggle}
            >
              {t("Cancel")}
            </StyledButton>
            <StyledButton
              style={{ height: "32px", width: "96px", marginLeft: "16px" }}
              onClick={saveCheckInfo}
            >
              {t("Save")}
            </StyledButton>
          </StyledDiv>
          <StyledDiv style={{ flexDirection: "row" }}>
            <StyledDeleteBtn
              style={{ height: "32px", width: "207px", marginLeft: "0px" }}
              onClick={deleteCheckIn}
            >
              {t("Delete")}
            </StyledDeleteBtn>
          </StyledDiv>
        </PopoverBody>
      </Popover>
    </>
  );
};
const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.div`
  font-size: ${(p) => p.theme["font-size"]};
  font-weight: ${(p) => p.theme["font-weight-600"]};
  margin: 16px 0 8px 0;
`;

const StyledButton = styled(Button)`
  height: 32px;
  font-size: ${(p) => p.theme["xs-font-size"]};
`;

const StyledDeleteBtn = styled.button`
  height: 33px;
  width: 162px;
  color: ${(p) => p.theme.black} !important;
  font-size: ${(p) => p.theme["xs-font-size"]};
  font-weight: ${(p) => p.theme["font-weight-600"]};
  outline: 0 !important;
  border: 1px solid ${(p) => p.theme.grey} !important;
  border-radius: ${(p) => p.theme.dropDown["border-radius"]};
  background: ${(p) => p.theme.lightGrey};
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.08);
  padding: 0 16px;
  cursor: pointer;
  &.disabled,
  &:disabled,
  &.disabled:hover,
  &:disabled:hover {
    cursor: default;
    border: 1px solid ${(p) => p.theme["disabled-grey"]} !important;
    background: ${(p) => p.theme["disabled-grey"]};
  }
`;

export default withI18n()(DisplayPopOver);
